import { render, staticRenderFns } from "./GroupChat.vue?vue&type=template&id=433907be&scoped=true"
import script from "./GroupChat.vue?vue&type=script&lang=js"
export * from "./GroupChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433907be",
  null
  
)

export default component.exports